/**
 * MINIMALIST_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Minimalist scoring.
 * Features:
 * - Static Harmonic Rhythm (Slow evolution)
 * - Flat Dynamic Range (Hypnotic consistency)
 * - Mid-Range focused Voice Distribution (Interlocking patterns)
 * - High Consonance (Diatonic)
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const MINIMALIST_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Harmonic Rhythm: Glacial.
    // Chords change very slowly (e.g. every 8-16 bars).
    harmonicRhythm: {
        ...SLOW_ARCHETYPE.harmonicRhythm,
        target: 8.0, // Avg bars per chord
        tolerance: 4.0,
        weight: 0.3
    },

    // Voice Distribution: Interlocking Mesh.
    // Avoid extreme highs/lows. Focus on the "pattern" in the middle.
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.10,
        mid: 0.70,
        high: 0.20,
        tolerance: 0.20,
        tuttiThreshold: 0.8, // Less likely to blast tutti
        weight: 0.2
    },

    // Dynamic Curve: Flat / Hypnotic.
    // We want consistency, not swells.
    // NOTE: Minimalist uses 'maxVariance' instead of 'minVariance'.
    // We override the whole object to avoid inheriting 'minVariance'.
    dynamicRange: {
        target: 'flat',
        maxVariance: 0.15, // Allow slight humanization but no big jumps
        weight: 0.4 // Critical for the genre feel
    },

    // Interval Entropy: Repetitive.
    // Steps or small skips.
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.40, // Accommodate Arpeggios (Leaps)
        weight: 0.1 // Less critical than dynamics
    }
};
